import { useEffect } from 'react';

/**
 * Sets `document.title` while a page is mounted and restores the previous value on unmount.
 *
 * No route in this application manages its title, so `index.html`'s static "MVP" is what
 * every page shows. Setting a title without restoring it would be worse than that: after
 * visiting a page that sets one, every subsequent route would keep showing the old page's
 * title, which is a more misleading state than a single generic title everywhere.
 *
 * Introduced for BugHerd #152. Applying titles across the rest of the application is a
 * separate piece of work; this hook is the reusable piece for it.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;

    return () => {
      document.title = previous;
    };
  }, [title]);
}
